import { trackAmplitudeEvent } from "../../amplitude";
import { STORIES_EVENTS } from "./storiesEvents";
import { requestJson } from "./storiesHelpers";

export const sendFeatureFeedback = async ({ extraInfo, featureFeedbackUrl, featureName, includeAccountDetails, message, targetLanguageName }) => {
  const trimmedMessage = message.trim();
  await requestJson({
    data: {
      feature_name: featureName,
      include_account_details: includeAccountDetails,
      language_studied: targetLanguageName,
      message: extraInfo ? `${trimmedMessage}\n\n---\n${extraInfo}` : trimmedMessage,
      platform: "web"
    },
    method: "post",
    url: featureFeedbackUrl
  });
  trackAmplitudeEvent(STORIES_EVENTS.FEATURE_FEEDBACK_SENT, { feature_name: featureName });
};
